// Itens do menu lateral + a regra de quem pode vê-los. Fica fora do Layout porque o Login/TrocarSenha também
// precisam dela: depois de entrar, o usuário só volta para a página que tentava abrir se ELE tem acesso a ela (bug de
// 25/10/2026: sair estando em /empresas e entrar como admin da imobiliária levava a "Sem permissão").
//
// Cada item já leva o nível mínimo exigido (mesma regra de visibilidade do menu do Laravel original,
// config/adminlte.php). Lembrete: nível MENOR = mais poder (1 superadmin, 2 admin da imobiliária, 3 corretor).
export const ITENS_MENU = [
  { rota: '/', rotulo: 'Dashboard', nivelMinimo: 3 },
  { rota: '/imoveis', rotulo: 'Imóveis', nivelMinimo: 3 },
  { rota: '/leads', rotulo: 'Leads', nivelMinimo: 3 },
  { rota: '/pedidos', rotulo: 'Pedidos', nivelMinimo: 3 },
  { rota: '/clientes', rotulo: 'Clientes', nivelMinimo: 3 },
  // `permissaoExtra` (22/10/2026): além do nível mínimo, um nivel 3 com essa ação concedida
  // também vê o item — perfil "Gerente de equipe" (ver src/permissoes.js `ACOES`).
  { rota: '/usuarios', rotulo: 'Usuários', nivelMinimo: 2, permissaoExtra: 'usuarios_ver' },
  // só admin da imobiliária (nivel 2): edita a PRÓPRIA empresa. Superadmin usa "Empresas".
  { rota: '/minha-empresa', rotulo: 'Minha empresa', nivelMinimo: 2, apenasNivel: 2 },
  { rota: '/empresas', rotulo: 'Empresas', nivelMinimo: 1 },
  { rota: '/taxonomia', rotulo: 'Taxonomia', nivelMinimo: 1 },
  { rota: '/feeds-xml', rotulo: 'Feeds XML', nivelMinimo: 1 },
  { rota: '/configuracoes', rotulo: 'Configurações', nivelMinimo: 1 },
  { rota: '/contas-whatslight', rotulo: 'Contas WhatsLight', nivelMinimo: 1 },
  { rota: '/escuta-grupos', rotulo: 'Escuta de grupos', nivelMinimo: 1 },
  { rota: '/apps-status', rotulo: 'Diagnóstico dos apps', nivelMinimo: 1 },
];

export function itemVisivel(item, usuario) {
  if (!usuario) return false;
  if (item.apenasNivel) return usuario.nivel === item.apenasNivel;
  if (usuario.nivel <= item.nivelMinimo) return true;
  return item.permissaoExtra ? usuario.permissoes?.[item.permissaoExtra] === true : false;
}

// "/empresas/emp_123?aba=2" -> o usuário pode abrir? Páginas que não são itens do menu (detalhe de imóvel,
// trocar senha, 404…) seguem a regra do próprio roteador/servidor, então aqui valem como permitidas.
export function destinoPermitido(destino, usuario) {
  if (typeof destino !== 'string' || !destino.startsWith('/') || destino.startsWith('//')) return false;
  const caminho = destino.split(/[?#]/)[0];
  const item = ITENS_MENU.filter((i) => i.rota !== '/').find((i) => caminho === i.rota || caminho.startsWith(i.rota + '/'));
  return item ? itemVisivel(item, usuario) : true;
}
